import { render, staticRenderFns } from "./LockBlockIcon.vue?vue&type=template&id=dbfbe3d6&"
import script from "./LockBlockIcon.vue?vue&type=script&lang=js&"
export * from "./LockBlockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports